import ContractsValidCollectionResponse, {
  ContractsValidCollectionResponseRailyContract,
  ContractsValidCollectionResponseTaxiContract,
  ContractsValidCollectionResponseTaxiContractBillingModel,
  ContractsValidCollectionResponseTaxiContractTaxiCorporation,
} from "../../../api/raily/contracts/valid-collection/contracts-valid-collection.response";
import BillingModel from "../../../types/billing-model";
import ContractsValidCollection, {
  ContractsValidCollectionRailyContract,
  ContractsValidCollectionTaxiContract,
  ContractsValidCollectionTaxiContractTaxiCorporation,
} from "./contracts-valid-collection";

const createBillingModel = (
  billingModel: ContractsValidCollectionResponseTaxiContractBillingModel,
): BillingModel => {
  switch (billingModel) {
    case ContractsValidCollectionResponseTaxiContractBillingModel.AB:
      return BillingModel.AB;
    case ContractsValidCollectionResponseTaxiContractBillingModel.ABA:
      return BillingModel.ABA;
    case ContractsValidCollectionResponseTaxiContractBillingModel.OTHER:
      return BillingModel.OTHER;
    case ContractsValidCollectionResponseTaxiContractBillingModel.SABS:
      return BillingModel.SABS;
  }
};

const createRailyContract = (
  railyContract: ContractsValidCollectionResponseRailyContract,
): ContractsValidCollectionRailyContract => {
  return {
    allowChargeDuringRide: railyContract.allowChargeDuringRide,
    cargoCompanyId: railyContract.cargoCompanyId,
    id: railyContract.id,
  };
};

const createRailyContracts = (
  railyContracts: ContractsValidCollectionResponseRailyContract[],
): ContractsValidCollectionRailyContract[] => {
  return railyContracts.map(createRailyContract);
};

const createTaxiContractTaxiCorporation = (
  taxiCorporation: ContractsValidCollectionResponseTaxiContractTaxiCorporation,
): ContractsValidCollectionTaxiContractTaxiCorporation => {
  return {
    displayName: taxiCorporation.displayName,
    id: taxiCorporation.id,
  };
};

const createTaxiContract = (
  taxiContract: ContractsValidCollectionResponseTaxiContract,
): ContractsValidCollectionTaxiContract => {
  return {
    allowChargeDuringRide: taxiContract.allowChargeDuringRide,
    billingModel: createBillingModel(taxiContract.billingModel),
    id: taxiContract.id,
    taxiCorporation: createTaxiContractTaxiCorporation(
      taxiContract.taxiCorporation,
    ),
  };
};

const createTaxiContracts = (
  taxiContracts: ContractsValidCollectionResponseTaxiContract[],
): ContractsValidCollectionTaxiContract[] => {
  return taxiContracts.map(createTaxiContract);
};

const create = (
  response: ContractsValidCollectionResponse,
): ContractsValidCollection => {
  return {
    railyContracts: createRailyContracts(response.data.railyContracts),
    taxiContracts: createTaxiContracts(response.data.taxiContracts),
  };
};

const contractsValidCollectionFactory = {
  create,
};

export default contractsValidCollectionFactory;
